module.exports = __webpack_public_path__ + "img/icon_resource.9349f2a3.png";